var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: "comm_record " + "comm_record" + _vm.uniqueId }, [
    !_vm.onlyShowAtinput
      ? _c(
          "div",
          { staticClass: "record_list" },
          [
            _vm._l(_vm.commlistdata, function(item, index) {
              return _c(
                "div",
                { staticClass: "list_one_item" },
                [
                  _c("div", { staticClass: "item_default" }, [
                    _c(
                      "div",
                      { staticClass: "item_top" },
                      [
                        _c("div", { staticClass: "item_peopleInfo" }, [
                          _c("img", {
                            staticClass: "item_headImg",
                            attrs: {
                              src: item.headImg
                                ? item.headImg
                                : _vm.defaultHeadImg,
                              alt: _vm.cutString(item.createUserName, 4),
                              title: item.createUserName
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "item_name",
                              attrs: { title: item.createUserName }
                            },
                            [_vm._v(_vm._s(item.createUserName))]
                          ),
                          _vm._v(" "),
                          item.isShowFollowBtn
                            ? _c("img", {
                                staticClass: "follow",
                                attrs: {
                                  src: "icons/pc/other/hr_gd_16_16.png?v=1.0",
                                  alt: "跟盯"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.follow(item)
                                  }
                                }
                              })
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("el-tooltip", { attrs: { placement: "top" } }, [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              item.fromObjType === "stdrsm"
                                ? _c("div", [_vm._v("来源：人才库")])
                                : _vm._e(),
                              _vm._v(" "),
                              item.fromObjType === "appfile" ||
                              item.fromObjType === "offer"
                                ? _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "recruit_process",
                                        staticStyle: { "margin-bottom": "5px" }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "招聘职位：" +
                                              _vm._s(item.positionname) +
                                              "（" +
                                              _vm._s(item.positionnumber) +
                                              "）"
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "recruit_process" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(item.recrustg) +
                                              "：" +
                                              _vm._s(item.recrustat)
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "item_source",
                            attrs: {
                              src: "icons/pc/other/hr_ryxx_16_16.png?v=1.0",
                              alt: "来源信息"
                            }
                          })
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !item.deleteState
                      ? _c("div", { staticClass: "item_body" }, [
                          _c("div", { staticClass: "item_text" }, [
                            _c("span", { staticStyle: { color: "#5582F3" } }, [
                              _vm._v("#" + _vm._s(item.commthemeName) + "# ")
                            ]),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(item.commthemeContent)
                              }
                            })
                          ]),
                          _vm._v(" "),
                          item.topicObj && item.topicObj.length
                            ? _c(
                                "div",
                                { staticClass: "item_topic" },
                                _vm._l(item.topicObj, function(
                                  topicItem,
                                  topicIndex
                                ) {
                                  return _c(
                                    "div",
                                    { staticClass: "topic_subitem" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "topic_title" },
                                        [_vm._v(_vm._s(topicItem.value) + "：")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "topic_content" },
                                        [
                                          _vm._v(
                                            _vm._s(topicItem.selectedValue)
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      topicIndex < item.topicObj.length - 1
                                        ? _c("span", [_vm._v("；")])
                                        : _vm._e()
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.commconName && item.conopt
                            ? _c(
                                "div",
                                { staticClass: "item_commconclusion" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "commconclusion_subitem" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "conclu_title" },
                                        [
                                          _vm._v(
                                            _vm._s(item.commconName) + "："
                                          )
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "conclu_content" },
                                        [_vm._v(_vm._s(item.conopt))]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "item_bottom" }, [
                            _c("div", { staticClass: "comment_time" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.dateFormat(
                                    "yyyy-MM-dd hh:mm",
                                    item.updateTimeDate
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            !item.deleteState
                              ? _c(
                                  "div",
                                  { staticClass: "item_op" },
                                  [
                                    _c(
                                      "el-popconfirm",
                                      {
                                        attrs: {
                                          "popper-class": "popConfirm",
                                          "hide-icon": true,
                                          title: _vm.getLangMsg(
                                            "commRecord_key001"
                                          )
                                        },
                                        on: {
                                          confirm: function($event) {
                                            return _vm.deleteCommRec(
                                              "theme",
                                              item.commrecId
                                            )
                                          }
                                        }
                                      },
                                      [
                                        item.isShowDeleteBtn
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "delete",
                                                attrs: { slot: "reference" },
                                                slot: "reference"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getLangMsg(
                                                      "commRecord_delete"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    item.isShowDeleteBtn
                                      ? _c("div", { staticClass: "divide" })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.isShowEditConopBtn
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "edit_clusion",
                                            on: {
                                              click: function($event) {
                                                return _vm.editClusion(item)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getLangMsg(
                                                  "commRecord_editClusion"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.isShowEditConopBtn
                                      ? _c("div", { staticClass: "divide" })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "reply",
                                        on: {
                                          click: function($event) {
                                            return _vm.reply("one", item)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getLangMsg("commRecord_reply")
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.deleteState
                      ? _c("div", { staticClass: "is_delete" }, [
                          _c("div", [
                            _vm._v(_vm._s(_vm.getLangMsg("commRecord_key002")))
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.dateFormat(
                                  "yyyy-MM-dd hh:mm",
                                  item.updateTimeDate
                                )
                              )
                            )
                          ])
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  item.commrcvs
                    ? _c(
                        "div",
                        { staticClass: "list_two" },
                        _vm._l(item.commrcvs, function(itemTwo, index) {
                          return _c("div", { staticClass: "list_two_item" }, [
                            _c("div", { staticClass: "item_default" }, [
                              _c(
                                "div",
                                { staticClass: "item_top" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "item_peopleInfo" },
                                    [
                                      _c("img", {
                                        staticClass: "item_two_headImg",
                                        attrs: {
                                          src: itemTwo.headImg
                                            ? itemTwo.headImg
                                            : _vm.defaultHeadImg,
                                          alt: itemTwo.createUserName,
                                          title: itemTwo.createUserName
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "item_name" }, [
                                        _vm._v(_vm._s(itemTwo.createUserName))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-tooltip",
                                    { attrs: { placement: "top" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content"
                                        },
                                        [
                                          itemTwo.fromObjType === "stdrsm"
                                            ? _c("div", [
                                                _vm._v("来源：人才库")
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          itemTwo.fromObjType === "appfile" ||
                                          item.fromObjType === "offer"
                                            ? _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "recruit_process",
                                                    staticStyle: {
                                                      "margin-bottom": "5px"
                                                    }
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        "招聘职位：" +
                                                          _vm._s(
                                                            itemTwo.positionname
                                                          ) +
                                                          "（" +
                                                          _vm._s(
                                                            itemTwo.positionnumber
                                                          ) +
                                                          "）"
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "recruit_process"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          itemTwo.recrustg
                                                        ) +
                                                          "：" +
                                                          _vm._s(
                                                            itemTwo.recrustat
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("img", {
                                        staticClass: "item_source",
                                        attrs: {
                                          src:
                                            "icons/pc/other/hr_ryxx_16_16.png?v=1.0",
                                          alt: "来源信息"
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !itemTwo.deleteState
                                ? _c("div", { staticClass: "item_body" }, [
                                    _c("div", { staticClass: "item_text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getLangMsg("commRecord_reply")
                                          )
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "__at_span",
                                            attrs: {
                                              "data-id":
                                                itemTwo.repliedcreatorId,
                                              contenteditable: "false"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "@" +
                                                _vm._s(
                                                  itemTwo.repliedcreatorName
                                                )
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(itemTwo.rcvcontent)
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "item_bottom" }, [
                                      _c(
                                        "div",
                                        { staticClass: "comment_time" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.dateFormat(
                                                "yyyy-MM-dd hh:mm",
                                                itemTwo.createTime
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !itemTwo.deleteState
                                        ? _c(
                                            "div",
                                            { staticClass: "item_op" },
                                            [
                                              _c(
                                                "el-popconfirm",
                                                {
                                                  attrs: {
                                                    "popper-class":
                                                      "popConfirm",
                                                    "hide-icon": true,
                                                    title: _vm.getLangMsg(
                                                      "commRecord_key001"
                                                    )
                                                  },
                                                  on: {
                                                    confirm: function($event) {
                                                      return _vm.deleteCommRec(
                                                        "reply",
                                                        itemTwo.commrcvId
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  itemTwo.isShowDeleteBtn
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass: "delete",
                                                          attrs: {
                                                            slot: "reference"
                                                          },
                                                          slot: "reference"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getLangMsg(
                                                                "commRecord_delete"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              itemTwo.isShowDeleteBtn
                                                ? _c("div", {
                                                    staticClass: "divide"
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "reply",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.reply(
                                                        "two",
                                                        item,
                                                        itemTwo
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getLangMsg(
                                                        "commRecord_reply"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              itemTwo.deleteState
                                ? _c("div", { staticClass: "is_delete" }, [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getLangMsg("commRecord_key003")
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dateFormat(
                                            "yyyy-MM-dd hh:mm",
                                            itemTwo.createTime
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ])
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("InputBox", {
                    key: item.commrecId,
                    ref: "inputBox" + item.commrecId,
                    refInFor: true,
                    attrs: {
                      atInputUniqueId: item.commrecId,
                      commrecItem: item,
                      cusParam_searchPeoples: _vm.cusParam_searchPeoples
                    }
                  })
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.commlistdata &&
            _vm.commlistdata.length &&
            _vm.cusParam_pageOpenType && _vm.cusParam_pageOpenType === "msg"
              ? _c("div", { staticClass: "more_data" }, [
                  _c("span", { on: { click: _vm.getMoreCommrec } }, [
                    _vm._v("查看全部")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            !(_vm.commlistdata && _vm.commlistdata.length)
              ? _c("div", { staticClass: "noListData" }, [
                  _c("img", { attrs: { src: _vm.nodataImg, alt: "" } }),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(_vm._s(_vm.getLangMsg("commRecord_key004")))
                  ])
                ])
              : _vm._e()
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.onlyShowAtinput
      ? _c(
          "div",
          { staticClass: "speech_board" },
          [
            _c("InputBox", {
              key: "0001",
              ref: "inputBox0001",
              staticClass: "input_area",
              attrs: {
                atInputUniqueId: "0001",
                cusParam_release: _vm.cusParam_release,
                cusParam_searchPeoples: _vm.cusParam_searchPeoples,
                onlyShowAtinput: _vm.onlyShowAtinput
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }